import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslocoDirective, TranslocoPipe } from '@jsverse/transloco';
import { IconComponent, CobaltButtonModule, CobaltSpinnerModule, CobaltInputModule } from '@msi/cobalt-prime';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { VerifyInput } from '@geocode-models/verify-input.model';

@Component({
  selector: 'app-address-geocode-dialog',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, TranslocoDirective, TranslocoPipe, IconComponent, CobaltButtonModule, CobaltSpinnerModule, CobaltInputModule],
  templateUrl: './address-geocode-dialog.component.html',
  styleUrl: './address-geocode-dialog.component.scss',
})
export class AddressGeocodeDialogComponent implements OnInit {
  private readonly dialogRef = inject(DynamicDialogRef);

  public processing = false;
  public GeocodeForm!: FormGroup;

  ngOnInit(): void {
    this.GeocodeForm = new FormGroup({
      locationName: new FormControl<string | null>(null),
      address: new FormControl<string>('', [Validators.required, Validators.minLength(1), Validators.maxLength(1024)]),
      city: new FormControl<string | null>(null),
      zipCode: new FormControl<string | null>(null),
      building: new FormControl<string | null>(null),
      apartment: new FormControl<string | null>(null),
      floor: new FormControl<string | null>(null),
      subdivision: new FormControl<string | null>(null),
    });
  }

  public onSubmit(): void {
    if (!this.GeocodeForm.valid) {
      return;
    }
    const f = this.GeocodeForm.controls;
    const result: VerifyInput = {
      address: f['address'].value,
      city: f['city'].value,
      zipCode: f['zipCode'].value,
      building: f['building'].value,
      apartment: f['apartment'].value,
      floor: f['floor'].value,
      subdivision: f['subdivision'].value,
      locationName: f['locationName'].value,
      magicKey: undefined,
    };
    this.dialogRef.close(result);
  }

  public onCancel(): void {
    this.dialogRef.close(null);
  }
}
